module.exports = __webpack_public_path__ + "img/ic-reset-pin.bdb988e7.svg";